import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-flag-2-fill text-white text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                国产第一页
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              专注展示中国自主品牌的核心价值与竞争优势。汇聚国产精品，助力国货崛起，为消费者提供最权威的国产品牌导航与推荐。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/keji-shuma" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">品牌分类</Link>
              <Link to="/category/keji-shuma" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">国货文章</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              品牌分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-300">
              <p>邮箱：contact@guochandiyiye.com</p>
              <p>电话：400-888-9999</p>
              <p>地址：北京市朝阳区建国路88号</p>
              <div className="flex items-center gap-3 mt-2">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-fill text-sm text-background-300"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-fill text-sm text-background-300"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-fill text-sm text-background-300"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 国产第一页 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}